module.exports = __webpack_public_path__ + "static/img/3.0ff04e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/3.png
// module id = SVsQ
// module chunks = 0